export const type = 'form.colorPicker';
